import React, {useEffect, useState} from 'react'
import {routes} from 'routes/routes'
import {LocalLink} from 'i18n/LocalLink'
import {useI18n} from 'i18n/I18nContext'

export function GDPRConsent() {
  const {t} = useI18n()
  const [visible, setVisible] = useState(false)
  useEffect(() => {
    if (typeof window === 'undefined') return
    const saved = localStorage.getItem('gdpr_consent') // 'accepted' | null
    setVisible(saved !== 'accepted')
  }, [])

  if (!visible) return null

  return (
    <div
      style={{
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 9999,
        background: '#111',
        color: '#fff',
        padding: '14px 16px',
        boxShadow: '0 -6px 24px rgba(0,0,0,0.25)',
      }}
      role="dialog"
      aria-live="polite"
    >
      <div
        style={{
          maxWidth: 1100,
          margin: '0 auto',
          display: 'flex',
          gap: 12,
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
        }}
      >
        <div style={{flex: '1 1 520px', minWidth: 260}}>
          {t('gdpr.text')}
          <br />
          <LocalLink
            to={routes.cookies}
            style={{color: '#9ad0ff', textDecoration: 'underline'}}
          >
            {t('footer.cookies')}
          </LocalLink>
          {' · '}
          <LocalLink
            to={routes.privacy}
            style={{color: '#9ad0ff', textDecoration: 'underline'}}
          >
            {t('footer.privacy')}
          </LocalLink>
          {' · '}
          <LocalLink
            to={routes.terms}
            style={{color: '#9ad0ff', textDecoration: 'underline'}}
          >
            {t('footer.terms')}
          </LocalLink>
        </div>

        <button
          type="button"
          onClick={() => {
            localStorage.setItem('gdpr_consent', 'accepted')
            setVisible(false)
          }}
          className="input__btn"
        >
          {t('gdpr.accept')}
        </button>
      </div>
    </div>
  )
}
